// extracted by mini-css-extract-plugin
export default {"circle_avatar":"circle_avatar_circle_avatar__i4i50"};